"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _immutable = _interopRequireDefault(require("immutable"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIBackButton = _interopRequireDefault(require("UIComponents/nav/UIBackButton"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UIMedia = _interopRequireDefault(require("UIComponents/layout/UIMedia"));

var _UIMediaRight = _interopRequireDefault(require("UIComponents/layout/UIMediaRight"));

var _UIMediaBody = _interopRequireDefault(require("UIComponents/layout/UIMediaBody"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UILoadingButton = _interopRequireDefault(require("UIComponents/button/UILoadingButton"));

var _UITruncateString = _interopRequireDefault(require("UIComponents/text/UITruncateString"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _preloadImage = _interopRequireDefault(require("FileManagerCore/utils/preloadImage"));

var _Constants = require("FileManagerCore/Constants");

var _PortalMetaCategoryIds = _interopRequireDefault(require("FileManagerCore/enums/PortalMetaCategoryIds"));

var _Files = require("FileManagerCore/actions/Files");

var _PortalMeta = require("FileManagerCore/actions/PortalMeta");

var _tracking = require("FileManagerCore/actions/tracking");

var _Auth = require("FileManagerCore/selectors/Auth");

var _FileDetails = require("FileManagerCore/selectors/FileDetails");

var _PortalMeta2 = require("FileManagerCore/selectors/PortalMeta");

var _FileAccess = require("../../enums/FileAccess");

var _FileExtensionFilters = _interopRequireDefault(require("../../enums/FileExtensionFilters"));

var _Configuration = require("../../selectors/Configuration");

var _Filter = require("../../selectors/Filter");

var _fileFiltering = require("../../utils/fileFiltering");

var _FromUrlInput = _interopRequireDefault(require("./FromUrlInput"));

var _FilterHintMessage = _interopRequireDefault(require("./FilterHintMessage"));

var _Constants2 = require("../../Constants");

var _ImportImageCopyrightConfirm = _interopRequireDefault(require("../modals/ImportImageCopyrightConfirm"));

var _ErrorMessages;

var Errors = (0, _keyMirror.default)({
  NOT_FOUND: null,
  DATA_URI: null,
  EXTENSION_FILTER: null,
  DOWNLOAD_URL_FAILED: null
});
var ErrorMessages = (_ErrorMessages = {}, (0, _defineProperty2.default)(_ErrorMessages, Errors.NOT_FOUND, 'loadingError'), (0, _defineProperty2.default)(_ErrorMessages, Errors.DATA_URI, 'dataUri'), (0, _defineProperty2.default)(_ErrorMessages, Errors.EXTENSION_FILTER, 'extensionFilter'), (0, _defineProperty2.default)(_ErrorMessages, Errors.DOWNLOAD_URL_FAILED, 'downloadUrlFailed'), _ErrorMessages);

function i18nKey(suffix) {
  return "FileManagerLib.panels.fromUrl." + suffix;
}

function getErrorMessage(error) {
  return _react.default.createElement(_FormattedMessage.default, {
    message: i18nKey("errors." + ErrorMessages[error])
  });
}

var FromUrlPanel = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FromUrlPanel, _Component);

  function FromUrlPanel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FromUrlPanel);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FromUrlPanel).call(this, props));

    _this.handleInsert = function () {
      var image = _this.state.image;
      var _this$props = _this.props,
          isUngatedForImageUrlImport = _this$props.isUngatedForImageUrlImport,
          onInsert = _this$props.onInsert,
          hasAcceptedImportCopyrightNotice = _this$props.hasAcceptedImportCopyrightNotice;

      if (!isUngatedForImageUrlImport) {
        onInsert(image, {
          target: 'from-url'
        });
        return;
      }

      if (hasAcceptedImportCopyrightNotice) {
        _this.downloadAndInsert();
      } else {
        _this.props.trackInteraction('fileManagerManageFiles', 'show-copyright-notice');

        _this.setState({
          copyrightModalOpen: true
        });
      }
    };

    _this.downloadAndInsert = function () {
      var tempImageUrl = _this.state.tempImageUrl;
      var _this$props2 = _this.props,
          onInsert = _this$props2.onInsert,
          uploadedFileAccess = _this$props2.uploadedFileAccess;
      var pathPaths = tempImageUrl.split('/');
      var name = pathPaths[pathPaths.length - 1];

      _this.props.downloadFromExternalUrl(tempImageUrl, uploadedFileAccess, {
        name: name
      }).then(function (file) {
        return onInsert(file, {
          target: 'import-from-url'
        });
      }).catch(function () {
        _this.setState({
          error: Errors.DOWNLOAD_URL_FAILED
        });
      });
    };

    _this.state = {
      tempImageUrl: '',
      image: null,
      error: null,
      isPreloading: false,
      copyrightModalOpen: false
    };
    _this.handleUrlChange = _this.handleUrlChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleKeyUp = _this.handleKeyUp.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleInsert = _this.handleInsert.bind((0, _assertThisInitialized2.default)(_this));
    _this.handlePreview = _this.handlePreview.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(FromUrlPanel, [{
    key: "getDimensions",
    value: function getDimensions(image) {
      return image.get('width') + " x " + image.get('height') + " px";
    }
  }, {
    key: "handleUrlChange",
    value: function handleUrlChange(event) {
      this.setState({
        tempImageUrl: event.target.value
      });
    }
  }, {
    key: "handlePreview",
    value: function handlePreview() {
      var _this2 = this;

      var _this$props3 = this.props,
          isUngatedForImageUrlImport = _this$props3.isUngatedForImageUrlImport,
          filterType = _this$props3.filterType,
          filteredExtensions = _this$props3.filteredExtensions;
      var tempImageUrl = this.state.tempImageUrl;

      if (tempImageUrl.startsWith('data:')) {
        this.setState({
          error: Errors.DATA_URI,
          image: null
        });
        return;
      }

      if (!tempImageUrl) {
        return;
      }

      this.setState({
        isPreloading: true
      });
      (0, _preloadImage.default)(tempImageUrl, function (meta) {
        var error = null;

        if (isUngatedForImageUrlImport && meta.extension && !filteredExtensions.isEmpty()) {
          if ((0, _fileFiltering.getIsFileExtensionNotSupported)(meta.extension, filteredExtensions, filterType)) {
            error = Errors.EXTENSION_FILTER;
          }
        }

        _this2.setState({
          image: _immutable.default.Map(Object.assign({
            id: -1,
            url: tempImageUrl,
            type: _Constants.FileTypes.IMG
          }, meta)),
          error: error,
          isPreloading: false
        });
      }, function () {
        _this2.setState({
          error: Errors.NOT_FOUND,
          image: null,
          isPreloading: false
        });
      });
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(event) {
      if (event.key === 'Enter') {
        this.handlePreview();
      }
    }
  }, {
    key: "renderInsertButton",
    value: function renderInsertButton() {
      var _this$props4 = this.props,
          isUngatedForImageUrlImport = _this$props4.isUngatedForImageUrlImport,
          isDownloadPending = _this$props4.isDownloadPending;

      if (isUngatedForImageUrlImport) {
        return _react.default.createElement(_UILoadingButton.default, {
          use: "primary",
          disabled: Boolean(this.state.error),
          onClick: this.handleInsert,
          loading: isDownloadPending
        }, _react.default.createElement(_FormattedMessage.default, {
          message: i18nKey('import')
        }));
      }

      return _react.default.createElement(_UIButton.default, {
        use: "primary",
        onClick: this.handleInsert
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "FileManagerLib.actions.insert"
      }));
    }
  }, {
    key: "renderCopyrightModal",
    value: function renderCopyrightModal() {
      var _this3 = this;

      return _react.default.createElement(_ImportImageCopyrightConfirm.default, {
        onConfirm: function onConfirm() {
          _this3.setState({
            copyrightModalOpen: false
          });

          _this3.props.updatePortalMeta(_PortalMetaCategoryIds.default.IMPORT_IMAGE_COPYRIGHT_NOTICE, _Constants.ImportImageCopyrightNoticeValues.ACCEPTED);

          _this3.downloadAndInsert();

          _this3.props.trackInteraction('fileManagerManageFiles', 'accept-copyright-notice');
        },
        onReject: function onReject() {
          _this3.setState({
            copyrightModalOpen: false
          });

          _this3.props.trackInteraction('fileManagerManageFiles', 'reject-copyright-notice');
        }
      });
    }
  }, {
    key: "renderPreview",
    value: function renderPreview() {
      var image = this.state.image;
      return _react.default.createElement("div", {
        className: "from-url-panel__preview m-top-4"
      }, _react.default.createElement("span", {
        className: "from-url-panel__preview-heading"
      }, _I18n.default.text(i18nKey('imagePreview'))), _react.default.createElement(_UIImage.default, {
        className: "from-url-panel__preview-image",
        src: image.get('url')
      }), _react.default.createElement(_UIMedia.default, {
        className: "m-top-6"
      }, _react.default.createElement(_UIMediaBody.default, null, _react.default.createElement(_Small.default, {
        use: "help",
        tagName: "p"
      }, _react.default.createElement(_UITruncateString.default, null, image.get('name') + "." + image.get('extension'))), _react.default.createElement(_Small.default, {
        use: "help",
        tagName: "p"
      }, _I18n.default.text('FileManagerLib.fileDetail.dimensions', {
        dimensions: this.getDimensions(image)
      }))), _react.default.createElement(_UIMediaRight.default, null, this.renderInsertButton())));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          onBack = _this$props5.onBack,
          filterType = _this$props5.filterType,
          type = _this$props5.type;
      var _this$state = this.state,
          tempImageUrl = _this$state.tempImageUrl,
          image = _this$state.image,
          error = _this$state.error,
          isPreloading = _this$state.isPreloading,
          isDownloadPending = _this$state.isDownloadPending,
          copyrightModalOpen = _this$state.copyrightModalOpen;
      var showImagePreview = image && (!error || error === Errors.EXTENSION_FILTER);
      return _react.default.createElement(_UIFlex.default, {
        direction: "column"
      }, filterType !== _FileExtensionFilters.default.NONE && _react.default.createElement(_FilterHintMessage.default, {
        drawerType: type
      }), _react.default.createElement(_UIBackButton.default, {
        className: "m-y-4"
      }, _react.default.createElement(_UILink.default, {
        onClick: onBack
      }, _react.default.createElement(_Small.default, null, _I18n.default.text('FileManagerLib.backButton')))), _react.default.createElement(_UIFormControl.default, {
        className: "from-url-panel__url-field",
        label: _I18n.default.text(i18nKey('imageUrl')),
        error: !!error,
        validationMessage: error ? getErrorMessage(error) : null
      }, _react.default.createElement(_FromUrlInput.default, {
        value: tempImageUrl,
        disabled: isPreloading || isDownloadPending,
        onKeyUp: this.handleKeyUp,
        onChange: this.handleUrlChange,
        onPreview: this.handlePreview
      })), showImagePreview && this.renderPreview(), copyrightModalOpen && this.renderCopyrightModal());
    }
  }]);
  return FromUrlPanel;
}(_react.Component);

FromUrlPanel.propTypes = {
  type: _propTypes.default.oneOf(Object.keys(_Constants2.DrawerTypes)).isRequired,
  onInsert: _propTypes.default.func.isRequired,
  onBack: _propTypes.default.func.isRequired,
  isUngatedForImageUrlImport: _propTypes.default.bool.isRequired,
  isDownloadPending: _propTypes.default.bool.isRequired,
  hasAcceptedImportCopyrightNotice: _propTypes.default.bool.isRequired,
  filterType: _propTypes.default.oneOf(Object.keys(_FileExtensionFilters.default)),
  filteredExtensions: _propTypes.default.instanceOf(_immutable.default.Set),
  uploadedFileAccess: _propTypes.default.oneOf(Object.keys(_FileAccess.DrawerFileAccess)).isRequired,
  downloadFromExternalUrl: _propTypes.default.func.isRequired,
  trackInteraction: _propTypes.default.func.isRequired,
  updatePortalMeta: _propTypes.default.func.isRequired
};
FromUrlPanel.defaultProps = {
  hasAcceptedImportCopyrightNotice: false
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isUngatedForImageUrlImport: (0, _Auth.getIsUngatedForImageUrlImport)(state),
    uploadedFileAccess: (0, _Configuration.getUploadedFileAccess)(state),
    isDownloadPending: (0, _FileDetails.getIsDownloadFromExternalUrlPending)(state),
    filterType: (0, _Filter.getFilterType)(state),
    filteredExtensions: (0, _Filter.getFilteredExtensions)(state),
    hasAcceptedImportCopyrightNotice: (0, _PortalMeta2.getHasAcceptedImportCopyrightNotice)(state)
  };
};

var mapDispatchToProps = {
  downloadFromExternalUrl: _Files.downloadFromExternalUrl,
  trackInteraction: _tracking.trackInteraction,
  updatePortalMeta: _PortalMeta.updatePortalMeta
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FromUrlPanel);

exports.default = _default;
module.exports = exports.default;